'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import * as CustomWidgetBuffersActions from 'DesignData/actions/CustomWidgetBuffers';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import IconSidebar from 'DesignEditorsUI/components/customWidgetEditor/sidebar/icon/IconSidebar';

function makeMapStateToProps() {
  return (state, props) => {
    const getCustomWidgetBuffer = customWidgetBuffersSelectors.makeGetCustomWidgetBuffer();
    const buffer = getCustomWidgetBuffer(state, props);
    return {
      customWidgetId: props.customWidgetId,
      isBufferLoaded: !!buffer,
      customWidgetIcon: buffer && buffer.icon || undefined
    };
  };
}

const mapDispatchToProps = {
  setIsSelectingIcon: CustomWidgetEditorOptionsActions.setIsSelectingIcon,
  updateCustomWidget: CustomWidgetBuffersActions.update
};

class IconSidebarContainer extends Component {
  constructor(...args) {
    super(...args);

    this.setIsSelectingIcon = isSelecting => {
      const {
        setIsSelectingIcon,
        customWidgetId
      } = this.props;
      setIsSelectingIcon(customWidgetId, isSelecting);
    };

    this.updateIcon = icon => {
      const {
        customWidgetId,
        updateCustomWidget
      } = this.props;
      updateCustomWidget(customWidgetId, {
        icon
      });
    };
  }

  shouldComponentUpdate(nextProps) {
    const {
      isBufferLoaded,
      customWidgetId,
      customWidgetIcon
    } = this.props;
    return !(isBufferLoaded === nextProps.isBufferLoaded && customWidgetId === nextProps.customWidgetId && customWidgetIcon === nextProps.customWidgetIcon);
  }

  render() {
    if (!this.props.isBufferLoaded) {
      return null;
    }

    return /*#__PURE__*/_jsx(IconSidebar, {
      customWidgetIcon: this.props.customWidgetIcon,
      setIsSelectingIcon: this.setIsSelectingIcon,
      updateIcon: this.updateIcon
    });
  }

}

IconSidebarContainer.propTypes = {
  isBufferLoaded: PropTypes.bool.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  customWidgetIcon: PropTypes.string,
  setIsSelectingIcon: PropTypes.func.isRequired,
  updateCustomWidget: PropTypes.func.isRequired
};
export default connect(makeMapStateToProps, mapDispatchToProps)(IconSidebarContainer);